export default __webpack_public_path__ + "2172df24e43dc67ce153ac5438c41eae.png";